import { render, staticRenderFns } from "./agentSMS.vue?vue&type=template&id=cb63ac56&scoped=true&"
import script from "./agentSMS.vue?vue&type=script&lang=js&"
export * from "./agentSMS.vue?vue&type=script&lang=js&"
import style0 from "./agentSMS.vue?vue&type=style&index=0&id=cb63ac56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb63ac56",
  null
  
)

export default component.exports